export default __webpack_public_path__ + "static/media/IMC-logo-square.31834bd5.svg";